export default "__VITE_ASSET__C_T6lNyk__"